var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.65 23.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.92,2.85,20.8.73a2.52,2.52,0,0,0-3.54,0L1.92,16.08h0l-.25.25a.56.56,0,0,0-.13.24L0,23a.49.49,0,0,0,.14.47.5.5,0,0,0,.35.14H.61l6.47-1.52A.56.56,0,0,0,7.32,22l.24-.25h0l13.2-13.2h0v0L22.21,7.1h0l.7-.7A2.5,2.5,0,0,0,22.92,2.85ZM20.44,7.46,16.2,3.21l.71-.71,4.24,4.24ZM7.22,20.68,3,16.43,15.49,3.91l4.24,4.26ZM2.39,17.27l4,4L1.17,22.48ZM22.21,5.68,21.86,6,17.62,1.79,18,1.44a1.49,1.49,0,0,1,2.12,0l2.12,2.12A1.49,1.49,0,0,1,22.21,5.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c542357fb1dbb1778d824e6c40b4e744.svg";
export { ForwardRef as ReactComponent };